<template>
  <v-menu
    v-model="timeOpen"
    :close-on-content-click="false"
    offset="40"
    transition="scale-transition"
    max-width="290px"
    min-width="290px"
  >
    <template #activator="{}">
      <vee-field
        v-slot="{ componentField, errors }"
        v-model="textTime"
        rules="time"
        :name="label"
      >
        <v-text-field
          v-mask="'##:##'"
          v-bind="componentField"
          :error-messages="errors"
          :label="label"
          prepend-inner-icon="$access_time"
          density="compact"
          variant="outlined"
          :disabled="!value"
          @click:prepend-inner="timeOpen = true"
          @blur="updateFromText"
        />
      </vee-field>
    </template>
    <v-time-picker
      v-if="timeOpen"
      v-model="internalValue"
      format="24hr"
      full-width
      :disabled="!value"
      :allowed-hours="allowedHours"
      :allowed-minutes="allowedMinutes"
      @input="inputFunc"
      @click:minute="updateMinute"
    />
  </v-menu>
</template>
<script>
import { Field as VeeField } from "vee-validate";
import { m } from '@/plugins/moment';

export default {
  name: "TextFieldTimePicker",
  components: {
    VeeField
  },
  props: {
    value: String,
    label: String,
    allowedHours: Function,
    allowedMinutes: Function
  },
  data: function () {
    return {
      internalHour: null,
      internalMinute: null,
      internalValue: null,
      timeOpen: false,
      textTime: ""
    };
  },
  computed: {
    momentValue: function () {
      const m = m(
        this.value,
        this.$t("commonStrings.dateValueFormat")
      );
      m.hour(this.internalHour);
      m.minute(this.internalMinute);

      return m.format(this.$t("commonStrings.dateValueFormat"));
    }
  },
  watch: {
    value(value) {
      if (value) {
        this.internalValue = m(
          value,
          this.$t("commonStrings.dateValueFormat")
        ).format(this.$t("commonStrings.timeDisplayFormat"));
        this.setHourAndMinute(this.internalValue);
        this.$emit("input", this.momentValue);
      } else {
        this.internalValue = null;
        this.internalHour = null;
        this.internalMinute = null;
      }
    }
  },
  mounted: function () {
    if (this.value) {
      this.internalValue = m(
        this.value,
        this.$t("commonStrings.dateValueFormat")
      ).format(this.$t("commonStrings.timeDisplayFormat"));
      this.setHourAndMinute(this.internalValue);
    }
  },
  methods: {
    updateFromText() {
      if (!this.textTime) {
        this.$emit("input", "");
        return;
      }

      this.setHourAndMinute(this.textTime);

      const val = m(
        this.momentValue,
        this.$t("commonStrings.dateValueFormat")
      );

      if (!val.isValid()) {
        return;
      }

      this.$emit("input", this.momentValue);
    },
    updateMinute: function () {
      this.timeOpen = false;
    },
    inputFunc: function (e) {
      if (e) {
        this.setHourAndMinute(e);
      }
      const val = m(
        this.momentValue,
        this.$t("commonStrings.dateValueFormat")
      );

      if (!val.isValid()) {
        return;
      }
      const textVal = val.format(this.$t("commonStrings.timeDisplayFormat"));
      this.textTime = textVal;
      this.$emit("input", this.momentValue);
    },
    setHourAndMinute(value) {
      const values = value.split(":");
      this.internalHour = parseInt(values[0], 10);
      this.internalMinute = parseInt(values[1], 10);
    }
  }
};
</script>
